import React, { useState } from 'react';
import { Alert } from '@strapi/design-system/Alert';
import { Button } from '@strapi/design-system/Button';
import authorizationHeader from '../../../../../shared/admin/utils/authorizationHeader';
import usePluginPermissions from '../../../../courses/admin/src/hooks/usePluginPermissions';
export const DuplicateButton = () => {
  const [status, setStatus] = useState(null);
  const isCreateURL = window.location.href.split('/').includes('create');
  const strapiBackendURL = strapi?.backendURL.length ? strapi.backendURL : window.location.origin;
  const {
    canCreateTestBank_courseView
  } = usePluginPermissions();
  const duplicateFetch = async () => {
    const currentURL = window.location.href;
    const urlArr = currentURL.split('/');
    const courseId = urlArr[urlArr.length - 1];
    const fetchData = await fetch(strapiBackendURL + `/courses/create-test-bank-from-course/${courseId}`, {
      method: 'POST',
      headers: {
        ...authorizationHeader
      }
    });
    const data = await fetchData.json();
    if (data?.title) {
      const state = {
        type: 'success',
        title: 'Success',
        message: 'test bank was created'
      };
      setStatus(state);
    }
    if (data?.error) {
      const state = {
        type: 'danger',
        title: 'Error',
        message: data?.error?.message
      };
      setStatus(state);
    }
  };
  const isDisabled = isCreateURL || !canCreateTestBank_courseView ? true : false;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: duplicateFetch,
    disabled: isDisabled
  }, "Create test bank"), status && /*#__PURE__*/React.createElement(Alert, {
    onClose: () => setStatus(null),
    closeLabel: "Close",
    title: status?.title,
    variant: status?.type
  }, status?.message));
};